jQuery.noConflict();
(function ($) {
  $(function () {


    function getTimeRemaining(endtime) {
      var t = Date.parse(endtime) - Date.parse(new Date());
      var seconds = Math.floor((t / 1000) % 60);
      var minutes = Math.floor((t / 1000 / 60) % 60);
      var hours = Math.floor((t / (1000 * 60 * 60)));
      return {
        'total': t,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
      };
    }

    function initializeClock(id, endtime) {

      function updateClock() {
        var t = getTimeRemaining(endtime);
        /*
        $('#' + id + ' .hours').text(('0' + t.hours).slice(-2));
        $('#' + id + ' .minutes').text(('0' + t.minutes).slice(-2));
        $('#' + id + ' .seconds').text(('0' + t.seconds).slice(-2));
        */
        
        $('#' + id + ' .hours').text('00');
        $('#' + id + ' .minutes').text('00');
        $('#' + id + ' .seconds').text('00');
        if (t.total <= 0) {
          clearInterval(timeinterval);
        }
      }

      updateClock();
      var timeinterval = setInterval(updateClock, 1000);
    }

    //var deadline = new Date(Date.parse(new Date()) + 15 * 24 * 60 * 60 * 1000);
    var deadline = new Date("March 9, 2017 23:59:59");
    initializeClock('clockdiv', deadline);
    initializeClock('clockdiv-mobile', deadline);
    initializeClock('clockdiv-presale', deadline);
    initializeClock('clockdiv-presale-mobile', deadline);


  });
})(jQuery);
